// extracted by mini-css-extract-plugin
module.exports = {"box":"finanzierungsvorhaben_box__3mqVH","error":"finanzierungsvorhaben_error__1zIP7"};